//Splash.tsx =================================================
import "./Util/Prototypes";

import * as MainMenu from "./Menus/MainMenu";
import * as Settings from "./Settings";

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

import React from "react";

let visible: boolean = true;

interface iProps {
}

//Render function.
export function Render(props: iProps) {

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Component did mount.
   React.useEffect(() => {
   }, []);

   function handleAgree() {
      //console.error("Handle Agree");
      visible = false;
      refresh();
      setTimeout(function () { MainMenu.render(); }, 600); //Focus name search box.
   }

   function handleDisagree() {
      //console.error("Handle Disagree");
      window.history.back();
   }

   function handleClose(event, reason) {
   //   console.error("Handle Close: reason: " + reason);
   //   if (reason === "backdropClick") {
      return;
   //   }
   }

   //Render components. Custom! <DialogContentText id="alert-dialog-description" style={{ color: 'red' }}>
   return (
      <Dialog
         disableEscapeKeyDown
         open={visible}
         onClose={handleClose}
         aria-labelledby="alert-dialog-title"
         aria-describedby="alert-dialog-description"
      >
         <DialogContent>
            <DialogContentText id="alert-dialog-description" style={{ color: 'black' }}>
               Welcome to <b>Augusta Maps</b> online.
               <br /><br />
               <b>Disclaimer:</b> Parcel information displayed contains current data and current Digest Year Values approved by the Richmond County Board of Assessors.
               Any change in valuations from the appeal process is updated at a later date, (generally in September). New Parcels for Digest Year 2026
               will display a $0 value. New map lines may take longer to produce than the updated information.&nbsp;&nbsp;
               <a href="Disclaimer.html" target="_blank"><b>Full Disclaimer</b></a>
               <br /><br />
            </DialogContentText>

            <div className="app-flex-row-center" style={{ marginTop: 3 }}>
               <img style={{ height: 80 }} src={Settings.webSiteLogo} alt="logo" />
            </div>
         </DialogContent>

         <DialogActions>
            <Button onClick={handleDisagree} color="info">
               Disagree
            </Button>
            <Button onClick={handleAgree} color="info" autoFocus>
               Agree
            </Button>
         </DialogActions>
      </Dialog>
   ); //end return.

} //end function.
